var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGasBulk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.897,
    height: 33.812,
    viewBox: "0 0 31.897 33.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8840",
    "data-name": "Group 8840",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_8",
    "data-name": "Union 8",
    d: "M7,30.812a2,2,0,0,1-2-2V27.032a1.992,1.992,0,0,1,.239-.948A13.465,13.465,0,0,1,5.8,4.351,4.816,4.816,0,0,1,10.6,0H18.3A4.817,4.817,0,0,1,23.1,4.351a13.465,13.465,0,0,1,.561,21.734,1.992,1.992,0,0,1,.239.948v1.779a2,2,0,0,1-2,2Z",
    transform: "translate(0)",
    fill: "#707070",
    stroke: "#707070",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_312",
    "data-name": "Ellipse 312",
    cx: 9.757,
    cy: 9.409,
    rx: 9.757,
    ry: 9.409,
    transform: "translate(4.583 8.898)",
    fill: "#707070",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_4279",
    "data-name": "Rectangle 4279",
    transform: "translate(3.886 5.414)",
    fill: "#ff7c49",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.909,
    height: 6.273,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19.909,
    height: 5.273,
    rx: 2.5,
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasBulk);
export default __webpack_public_path__ + "static/media/GasBulk.71195a6e698efb455acfd3f188ae22ff.svg";
export { ForwardRef as ReactComponent };